﻿import { action, makeObservable, observable } from "mobx";
import { Feature } from "ol";

import { PickReports, IPickReportId } from "../models/pickReports/IPickReports";
import { IPickReportQueryExtended, PickReportUrl } from "../models/pickReports/IFetchPickReports";
import { SpacesUrl } from "../models/pickReports/IFetchPickReportSpaces";
import { PickReportInstanceUrl } from "../models/pickReports/IFetchPickReportDetails";

export interface PickReportUrls {
    pickReports: PickReportUrl,
    file: PickReportInstanceUrl,
    image: PickReportInstanceUrl,
    geometry?: PickReportInstanceUrl,
    spaces?: SpacesUrl,    
}

export class PickReportStore {
    public active: boolean = false;  
    public selected: IPickReportId | undefined = undefined;
    public geometries: Feature[] | undefined = undefined;
    public query: IPickReportQueryExtended | undefined = undefined;
    public reports: PickReports | undefined = undefined;
    public urls: PickReportUrls | undefined = undefined;
        
    constructor() {
        makeObservable(this, {
            active: observable,
            selected: observable,
            geometries: observable,
            query: observable,
            reports: observable,
            urls: observable,
            setActive: action.bound,
            setSelected: action.bound,
            setGeometries: action.bound,
            setQuery: action.bound,
            setReports: action.bound,
            setUrls: action.bound,
            reset: action.bound            
        });
    }

    public setUrls(urls: PickReportUrls) {
        this.urls = urls
    }
   
    public setQuery(query: IPickReportQueryExtended | undefined) {
        this.query = query;
    } 

    public setReports(reports: PickReports | undefined) {
        this.reports = reports;
    }       

    public setSelected(selected: IPickReportId | undefined) {
        this.selected = selected;
    }

    public setGeometries(geometries: Feature[] | undefined) {
        this.geometries = geometries;
    }

    public setActive(active: boolean) {
        this.active = active;                  
    }
    
    public reset() {
        this.active = false;
        this.selected = undefined;
        this.query = undefined;
        this.reports = undefined;
        this.geometries = undefined        
    }
}